export async function apiHandler<T>(apiCall: () => Promise<T>): Promise<T> {
    try {
        return await apiCall();
    } catch (e) {
        if (e instanceof Response) {
            let message: string;
            try {
                const body = await e.json();
                if (body.hasOwnProperty("message")) {
                    if (Array.isArray(body.message)) {
                        message = body.message.map((m: {toString(): string}) => m.toString()).join("\n");
                    } else if (typeof body.message === "string") {
                        message = body.message;
                    } else {
                        message = body.message.toString();
                    }
                } else {
                    message = "No further information included.";
                }
            } catch (innerError) {
                message = await e.text();
            }

            switch (e.status) {
            case 400:
                alert(`Your request was malformed.\n\n${message}`);
                break;
            case 403:
                alert(`You are not authorized to perform this action. Please check your permissions.\n\nError: ${message}`);
                break;
            case 500:
                alert(`A server error has occurred. Please try again. If the error persists, please reach out to support.\n\nError: ${message}`);
                break;
            default:
                alert(`An unknown error has occurred.\n\nError: ${message}`);
                break;
            }
        } else {
            alert(`An unknown error occurred.${e.message}`);
        }
        throw e;
    }
}
